import template from './modalQuestionCadastral.html';
import controller from './modalQuestionCadastral.controller';
import './modalQuestionCadastral.scss';

let modalQuestionCadastralComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<',
    resetFormCadastral: '&',
    showCadastralReference: '&',
  },
  template,
  controller
};

export default modalQuestionCadastralComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/cadastralReferenceMobile/modalQuestionCadastral/modalQuestionCadastral.component.js